import { render, staticRenderFns } from "./TribunalSelect.vue?vue&type=template&id=6eb93df6&"
import script from "./TribunalSelect.vue?vue&type=script&lang=js&"
export * from "./TribunalSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports